// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Licensed under the Apache License, Version 2.0 (https://www.apache.org/licenses/LICENSE-2.0).

// Cloudscape's English strings, so built-in controls get accessible names (task 12.2). Without an I18nProvider,
// built-in controls such as the modal close button, Multiselect token remove buttons, and dismissible Alerts render
// with no accessible name (axe "button-name", critical) unless every usage passes its own label.
import type { ReactNode } from 'react';
import { I18nProvider } from '@cloudscape-design/components/i18n';
import enMessages from '@cloudscape-design/components/i18n/messages/all.en';

const MESSAGES = [enMessages];

export function CloudscapeStrings({ children }: { children: ReactNode }) {
  return (
    <I18nProvider locale="en" messages={MESSAGES}>
      {children}
    </I18nProvider>
  );
}
